import CountDown from './count-down'

export default CountDown